import * as storeNS from '@/store/namespace';
import * as NS from './namespace';
import { ActionContext } from 'vuex';
import { HttpService } from '@/services/http-service';
import { IUser } from '@/model/security';
import { IIndicator, ISensorDevice } from '@/model/meta';

const actions: NS.IAdministrationActions = {
    resetForm({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any): void {
        commit('SET_FORM_REQUEST_RESET');
    },

    async loadUsersGrid({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any) {
        commit('SET_LOADING_REQUEST');

        try {
            const res = await HttpService.get<IUser[]>('/user/all');
            commit('SET_USERSGRID_LOADING_SUCCESS', res.data );
        } catch (error) {
            commit('SET_LOADING_FAIL', error);
        }
    },
    async createUser({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: IUser): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const res = await HttpService.post('/user/', payload);
            if (payload.availableDevices !== undefined && payload.availableDevices.length > 0) {
                const devicesIds = payload.availableDevices.map(item => { return item.sensorDeviceId; } );
                await HttpService.put('/user/devices/' + payload.userId, devicesIds);
            }
            commit('SET_INSERT_USER', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async deleteUser({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const user = payload as IUser;
            const res = await HttpService.delete('/user/' + user.userId);
            commit('SET_DELETE_USER', user );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async updateUser({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: IUser): Promise<boolean> {
        commit('SET_FORM_REQUEST');
        
        try {
            const res = await HttpService.put('/user/', payload);
            if (payload.availableDevices !== undefined && payload.availableDevices.length > 0) {
                const devicesIds = payload.availableDevices.map(item => { return item.sensorDeviceId; } );
                await HttpService.put('/user/devices/' + payload.userId, devicesIds);
            }
            commit('SET_UPDATE_USER', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async loadDevicesSubGrid({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any): Promise<boolean> {
        try {
            const res = await HttpService.get<ISensorDevice[]>('/device/all');
            commit('SET_DEVICESSUBGRID_LOADING_SUCCESS', res.data );
            return true;
        } catch (error) {
            return false;
        }
    },
    async loadDevicesForUser({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: IUser): Promise<boolean> {
        try {
            const res = await HttpService.get<ISensorDevice[]>('/user/devices/entities/all/' + payload.userId);
            commit('SET_USER_DEVICE_SUCCESS', {user: payload, devices: res.data} );
            return true;
        } catch (error) {
            commit('SET_USER_DEVICES_FAIL', payload );
            return false;
        }
    },


    async loadIndicatorsGrid({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any) {
        commit('SET_LOADING_REQUEST');

        try {
            const res = await HttpService.get<IIndicator[]>('/indicator/all');
            commit('SET_INDICATORSGRID_LOADING_SUCCESS', res.data );
        } catch (error) {
            commit('SET_LOADING_FAIL', error);
        }
    },
    async createIndicator({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const indicator = payload as IIndicator;
            const res = await HttpService.post('/indicator/', indicator);
            commit('SET_INSERT_INDICATOR', indicator );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async deleteIndicator({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const indicator = payload as IIndicator;
            const res = await HttpService.delete('/indicator/' + indicator.indicatorId);
            commit('SET_DELETE_INDICATOR', indicator );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async updateIndicator({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any): Promise<boolean> {
        commit('SET_FORM_REQUEST');
        
        try {
            const indicator = payload as IIndicator;
            const res = await HttpService.put('/indicator/', indicator);
            commit('SET_UPDATE_INDICATOR', indicator );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },


    async loadDevicesGrid({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any) {
        commit('SET_LOADING_REQUEST');

        try {
            const res = await HttpService.get<ISensorDevice[]>('/device/all');
            commit('SET_DEVICESGRID_LOADING_SUCCESS', res.data );
        } catch (error) {
            commit('SET_LOADING_FAIL', error);
        }
    },
    async loadIndicatorsSubGrid({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: any) {
        try {
            const res = await HttpService.get<IIndicator[]>('/indicator/all');
            commit('SET_INDICATORSSUBGRID_LOADING_SUCCESS', res.data );
            return true;
        } catch (error) {
            return false;
        }
    },
    async loadIndicatorsForDevice({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: ISensorDevice) {
        try {
            const res = await HttpService.get<IIndicator[]>('/device/indicators/entities/all/' + payload.sensorDeviceId);
            commit('SET_DEVICES_INDICATORS_SUCCESS', {device: payload, indicators: res.data} );
            return true;
        } catch (error) {
            commit('SET_DEVICES_INDICATORS_FAIL', payload );
            return false;
        }
    },
    async createDevice({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: ISensorDevice): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const res = await HttpService.post('/device/', payload);
            if (payload.availableIndicators !== undefined && payload.availableIndicators.length > 0) {
                const indicatorsIds = payload.availableIndicators.map(item => { return item.indicatorId; } );
                await HttpService.put('/device/indicators/' + payload.sensorDeviceId, indicatorsIds);
            }
            commit('SET_INSERT_DEVICE', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async deleteDevice({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: ISensorDevice): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const res = await HttpService.delete('/device/' + payload.sensorDeviceId);
            commit('SET_DELETE_DEVICE', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async updateDevice({ commit, state }: ActionContext<NS.IAdministrationState, storeNS.IState>, payload: ISensorDevice): Promise<boolean> {
        commit('SET_FORM_REQUEST');
        
        try {
            const res = await HttpService.put('/device/', payload);
            if (payload.availableIndicators !== undefined && payload.availableIndicators.length > 0) {
                const indicatorsIds = payload.availableIndicators.map(item => { return item.indicatorId; } );
                await HttpService.put('/device/indicators/' + payload.sensorDeviceId, indicatorsIds);
            }
            commit('SET_UPDATE_DEVICE', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
};

/** Реализация действий модуля администрирования */
export default actions;